/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setDivergenceListFilter } from "../index";

export const useDivergenceFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(setDivergenceListFilter({ key, value }));

  return { updateFilter };
};
